enum BusinessSizeType {
  NotSet = 0,
  OneTo10 = 1,
  TenTo50 = 2,
  FiftyTo200 = 3,
  MoreThan200 = 4
}

export default BusinessSizeType;
